{
  "collectionLabel": "建议"
}
